<template>
  <div class="step voucher-info">
    <p v-html="labels.voucherIntro"></p>
    <TextBox
      :label="labels.voucherNumber"
      mandatory
      v-model="voucher"
      :invalid="!voucherIsValid"
      :validation-message="errorMsg"
      @change="checkVoucher"
    ></TextBox>
    <CheckboxGroup inline>
      <Checkbox label="" v-model="agreeToTerms" :invalid="mustAgree"></Checkbox>
      <div v-html="labels.termsAndConditions"></div>
    </CheckboxGroup>
  </div>
</template>

<script>
import { FlatButton, TextBox, CheckboxGroup, Checkbox } from "clariant-vue3-forms";
import { DataLayer, Labels, State, Utils } from "../services.js";

export default {
  name: "VoucherInformation",
  emits: ["setVoucherCounter"],
  components: {
    FlatButton,
    TextBox,
    CheckboxGroup, 
    Checkbox
  },
  data() {
    return {
      labels: Labels,
      voucher: "",
      errorMsg: "",
      agreeToTerms: false,
      voucherIsValid: true,
      mustAgree: false
    };
  },
  methods: {
    validateStep() {
        if (!this.agreeToTerms) {
          this.mustAgree = true;
          return false;
        } else this.mustAgree = false;
        if(this.voucher.length === 0) { 
            this.voucherIsValid = false;
            this.errorMsg = this.labels.emptyVoucherMsg;
            };
        return this.voucherIsValid;
    },
    checkVoucher(){
        DataLayer.checkVoucher(this.voucher)
        .then((res) => {
            this.voucherIsValid = res.remainingSamples > 0
            if(!this.voucherIsValid) {
              this.errorMsg = this.labels.noRemainingSamples;
            }
            else {
              const voucherData = {
                voucherNumber: this.voucher,
                freeSamples: res.remainingSamples,
                totalSamples: res.totalSamples,
                distributor: res.distributor
              }
              this.$emit("setVoucherCounter", voucherData);
            }
        })
        .catch((err) => {
            this.voucherIsValid = false;
            this.errorMsg = this.labels.noRemainingSamples;
        });
    }
  },
};
</script>

<style scoped>
.voucher-info {
  margin-top: 20px;
  min-height: 620px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
</style>